import type { GenericTranslationsObject } from '@payloadcms/translations'

export const pt: GenericTranslationsObject = {
  $schema: '../translation-schema.json',
  'plugin-redirects': {
    customUrl: 'URL Personalizada',
    documentToRedirect: 'Documento para Redirecionar',
    fromUrl: 'URL de Origem',
    internalLink: 'Link Interno',
    redirectType: 'Tipo de Redirecionamento',
    toUrlType: 'Tipo de Destino',
  },
}
